if (!customElements.get('sesseq-journal')) {
  customElements.define('sesseq-journal', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const originalTitle = document.title;
      this.views = [...this.querySelectorAll('[data-view]')];
      const show = (selected, move) => {
        this.views.forEach(view => { view.hidden = view !== selected; });
        this.classList.add('is-ready');
        document.title = selected.dataset.view === 'overview' ? originalTitle : `${selected.querySelector('h1').textContent} | SESSEQ Design Guide`;
        if (move) {
          this.scrollIntoView({ behavior: 'instant', block: 'start' });
          selected.querySelector('h1')?.focus({ preventScroll: true });
        }
      };
      const route = (move = false) => {
        const selected = this.views.find(view => view.dataset.view === location.hash.slice(1)) || this.views[0];
        show(selected, move);
      };
      this.drawer = this.querySelector('.sqj-drawer');
      const restore = () => {
        if (!this.savedScroll) return;
        document.body.style.overflow = this.savedScroll.overflow;
        document.body.style.paddingRight = this.savedScroll.padding;
        this.savedScroll = null;
        this.lookTrigger?.focus({ preventScroll: true });
      };
      this.restoreScroll = restore;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-shop-look]');
        if (trigger) {
          const source = [...this.querySelectorAll('template[data-look-template]')].find(item => item.dataset.lookTemplate === trigger.dataset.shopLook);
          if (!source || !this.drawer) return;
          this.lookTrigger = trigger;
          this.drawer.querySelector('[data-look-title]').textContent = source.dataset.lookTitle;
          this.drawer.querySelector('[data-look-content]').replaceChildren(source.content.cloneNode(true));
          this.savedScroll = { overflow: document.body.style.overflow, padding: document.body.style.paddingRight };
          const scrollbar = window.innerWidth - document.documentElement.clientWidth;
          if (scrollbar > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
          document.body.style.overflow = 'hidden';
          this.drawer.showModal();
          this.drawer.querySelector('.sqj-drawer__body').scrollTop = 0;
        }
        if (event.target.closest('[data-close-look]')) this.drawer?.close();
      }, options);
      this.drawer?.addEventListener('close', restore, options);
      this.drawer?.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, options);
      window.addEventListener('hashchange', () => { if (this.drawer?.open) this.drawer.close(); }, options);
      route();
      window.addEventListener('hashchange', () => route(true), options);
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.hash === location.hash) { event.preventDefault(); route(true); }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('[data-view]');
        if (!selected) return;
        if (this.drawer?.open) this.drawer.close();
        show(selected, false);
        if (window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.hash = selected.dataset.view;
          window.history.replaceState(window.history.state, '', url);
        }
        event.target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, options);
    }
    disconnectedCallback() {
      if (this.drawer?.open) this.drawer.close();
      this.restoreScroll?.();
      this.controller?.abort();
      this.controller = null;
    }
  });
}


